import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { EASE } from "../../lib/motion";
import { scAmcLogin } from "../../lib/sifcontrolApi";

export default function SifControlAmcLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await scAmcLogin(email, password);
            toast.success("Welcome back.");
            navigate("/sifcontrol/amc/dashboard");
        } catch (err) {
            const detail = err?.response?.data?.detail || "Could not sign in.";
            toast.error(typeof detail === "string" ? detail : "Could not sign in.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="py-16 md:py-24" data-testid="sc-amc-login-page">
            <div className="mx-auto max-w-[460px] px-4 md:px-6">
                <motion.div
                    initial={{ opacity: 0, y: 16, filter: "blur(6px)" }}
                    animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                    transition={{ duration: 0.9, ease: EASE }}
                    className="rounded-3xl border border-oth-line bg-white p-8 md:p-10"
                >
                    <div className="text-[11px] uppercase tracking-[0.22em] text-oth-ink3 font-body">AMC portal</div>
                    <h1 className="mt-1 font-display text-3xl md:text-4xl font-semibold tracking-tight text-oth-ink">Sign in</h1>
                    <p className="mt-3 text-sm font-body text-oth-ink2">
                        AMC accounts can only edit designated non-price data for their own SIFs.
                    </p>
                    <form onSubmit={submit} className="mt-6 space-y-3" data-testid="sc-amc-login-form">
                        <input
                            type="email"
                            className="w-full h-11 px-4 rounded-full border border-oth-line bg-white text-sm focus:outline-none focus:border-oth-ink"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            data-testid="sc-amc-login-email"
                        />
                        <input
                            type="password"
                            className="w-full h-11 px-4 rounded-full border border-oth-line bg-white text-sm focus:outline-none focus:border-oth-ink"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            data-testid="sc-amc-login-password"
                        />
                        <button
                            type="submit"
                            disabled={loading}
                            className="btn-pill btn-pill-dark w-full mt-2"
                            data-testid="sc-amc-login-submit"
                        >
                            {loading ? "Signing in…" : "Continue"} <ArrowUpRight size={14} />
                        </button>
                    </form>
                    <div className="mt-6 text-[11px] font-body text-oth-ink3">
                        Are you a SIF Control administrator?{" "}
                        <Link to="/adminoth" className="underline hover:text-oth-ink" data-testid="sc-amc-login-admin-link">
                            Sign in here
                        </Link>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
